import type { ChapterDef, WorldDef } from '@md/engine';
import { ChaptersFileSchema, type Level, LevelSchema, WorldFileSchema } from '@md/shared';
import factoryChaptersJson from '../worlds/factory/chapters.json' with { type: 'json' };
import factoryCh1L1Json from '../worlds/factory/levels/ch1-l1.json' with { type: 'json' };
import factoryCh1L2Json from '../worlds/factory/levels/ch1-l2.json' with { type: 'json' };
import factoryCh1L3Json from '../worlds/factory/levels/ch1-l3.json' with { type: 'json' };
import factoryCh1L4Json from '../worlds/factory/levels/ch1-l4.json' with { type: 'json' };
import factoryCh1L5Json from '../worlds/factory/levels/ch1-l5.json' with { type: 'json' };
import factoryCh1L6Json from '../worlds/factory/levels/ch1-l6.json' with { type: 'json' };
import factoryCh2L1Json from '../worlds/factory/levels/ch2-l1.json' with { type: 'json' };
import factoryCh2L2Json from '../worlds/factory/levels/ch2-l2.json' with { type: 'json' };
import factoryCh2L3Json from '../worlds/factory/levels/ch2-l3.json' with { type: 'json' };
import factoryCh2L4Json from '../worlds/factory/levels/ch2-l4.json' with { type: 'json' };
import factoryCh2L5Json from '../worlds/factory/levels/ch2-l5.json' with { type: 'json' };
import factoryCh2L6Json from '../worlds/factory/levels/ch2-l6.json' with { type: 'json' };
import factoryCh3L1Json from '../worlds/factory/levels/ch3-l1.json' with { type: 'json' };
import factoryCh3L2Json from '../worlds/factory/levels/ch3-l2.json' with { type: 'json' };
import factoryCh3L3Json from '../worlds/factory/levels/ch3-l3.json' with { type: 'json' };
import factoryCh3L4Json from '../worlds/factory/levels/ch3-l4.json' with { type: 'json' };
import factoryCh3L5Json from '../worlds/factory/levels/ch3-l5.json' with { type: 'json' };
import factoryCh3L6Json from '../worlds/factory/levels/ch3-l6.json' with { type: 'json' };
import factoryCh4L1Json from '../worlds/factory/levels/ch4-l1.json' with { type: 'json' };
import factoryCh4L2Json from '../worlds/factory/levels/ch4-l2.json' with { type: 'json' };
import factoryCh4L3Json from '../worlds/factory/levels/ch4-l3.json' with { type: 'json' };
import factoryCh4L4Json from '../worlds/factory/levels/ch4-l4.json' with { type: 'json' };
import factoryCh4L5Json from '../worlds/factory/levels/ch4-l5.json' with { type: 'json' };
import factoryCh4L6Json from '../worlds/factory/levels/ch4-l6.json' with { type: 'json' };
import factoryCh4L7Json from '../worlds/factory/levels/ch4-l7.json' with { type: 'json' };
import factoryCh5L1Json from '../worlds/factory/levels/ch5-l1.json' with { type: 'json' };
import factoryCh5L2Json from '../worlds/factory/levels/ch5-l2.json' with { type: 'json' };
import factoryCh5L3Json from '../worlds/factory/levels/ch5-l3.json' with { type: 'json' };
import factoryCh5L4Json from '../worlds/factory/levels/ch5-l4.json' with { type: 'json' };
import factoryCh5L5Json from '../worlds/factory/levels/ch5-l5.json' with { type: 'json' };
import factoryCh5L6Json from '../worlds/factory/levels/ch5-l6.json' with { type: 'json' };
import factoryWorldJson from '../worlds/factory/world.json' with { type: 'json' };
import rooftopsChaptersJson from '../worlds/rooftops/chapters.json' with { type: 'json' };
import rooftopsCh1L1Json from '../worlds/rooftops/levels/ch1-l1.json' with { type: 'json' };
import rooftopsCh1L2Json from '../worlds/rooftops/levels/ch1-l2.json' with { type: 'json' };
import rooftopsCh1L3Json from '../worlds/rooftops/levels/ch1-l3.json' with { type: 'json' };
import rooftopsCh1L4Json from '../worlds/rooftops/levels/ch1-l4.json' with { type: 'json' };
import rooftopsCh1L5Json from '../worlds/rooftops/levels/ch1-l5.json' with { type: 'json' };
import rooftopsCh1L6Json from '../worlds/rooftops/levels/ch1-l6.json' with { type: 'json' };
import rooftopsCh2L1Json from '../worlds/rooftops/levels/ch2-l1.json' with { type: 'json' };
import rooftopsCh2L2Json from '../worlds/rooftops/levels/ch2-l2.json' with { type: 'json' };
import rooftopsCh2L3Json from '../worlds/rooftops/levels/ch2-l3.json' with { type: 'json' };
import rooftopsCh2L4Json from '../worlds/rooftops/levels/ch2-l4.json' with { type: 'json' };
import rooftopsCh2L5Json from '../worlds/rooftops/levels/ch2-l5.json' with { type: 'json' };
import rooftopsCh2L6Json from '../worlds/rooftops/levels/ch2-l6.json' with { type: 'json' };
import rooftopsCh3L1Json from '../worlds/rooftops/levels/ch3-l1.json' with { type: 'json' };
import rooftopsCh3L2Json from '../worlds/rooftops/levels/ch3-l2.json' with { type: 'json' };
import rooftopsCh3L3Json from '../worlds/rooftops/levels/ch3-l3.json' with { type: 'json' };
import rooftopsCh3L4Json from '../worlds/rooftops/levels/ch3-l4.json' with { type: 'json' };
import rooftopsCh3L5Json from '../worlds/rooftops/levels/ch3-l5.json' with { type: 'json' };
import rooftopsCh3L6Json from '../worlds/rooftops/levels/ch3-l6.json' with { type: 'json' };
import rooftopsWorldJson from '../worlds/rooftops/world.json' with { type: 'json' };

/**
 * Worlds livrés avec le jeu (spec §2 : `worlds/<world>/…`).
 *
 * Les niveaux « seed » sont des fichiers JSON versionnés avec le code ; ils
 * sont validés par zod AU CHARGEMENT du module, jamais après. Ces mêmes
 * fichiers sont importés en base au boot du serveur (upsert idempotent) et
 * l'API sert les niveaux depuis SQLite.
 *
 * Deux worlds sont livrés :
 *
 * | World | Chapitres | Niveaux |
 * |---|---|---|
 * | `factory` — L'Usine | 5 | 31 |
 * | `rooftops` — Les Toits | 3 | 18 |
 *
 * Chaque niveau passe le pipeline complet du solveur (spec §8), prouvé par
 * `src/world.test.ts`. Le regroupement par chapitre est fait **par world** :
 * deux worlds peuvent avoir un chapitre 1, leurs niveaux ne doivent jamais se
 * mélanger.
 */

/** Assemble un world à partir de ses trois fichiers, zod à la frontière. */
function buildWorld(
  worldJson: unknown,
  chaptersJson: unknown,
  levelJsons: readonly unknown[],
): WorldDef {
  const world = WorldFileSchema.parse(worldJson);
  const chaptersFile = ChaptersFileSchema.parse(chaptersJson);

  /** Niveaux de CE world, indexés par numéro de chapitre. */
  const levelsByChapter = new Map<number, Level[]>();
  for (const json of levelJsons) {
    const level = LevelSchema.parse(json);
    const bucket = levelsByChapter.get(level.meta.chapter);
    if (bucket) {
      bucket.push(level);
    } else {
      levelsByChapter.set(level.meta.chapter, [level]);
    }
  }

  const chapters: ChapterDef[] = chaptersFile.chapters.map((chapter) => ({
    chapter: chapter.chapter,
    name: chapter.name,
    difficulty: chapter.difficulty,
    mechanics: chapter.mechanics,
    minCoopPassages: chapter.minCoopPassages,
    levels: (levelsByChapter.get(chapter.chapter) ?? []).sort(
      (a, b) => a.meta.level - b.meta.level,
    ),
  }));

  return {
    id: world.id,
    name: world.name,
    theme: world.theme,
    description: world.description,
    chapters,
  };
}

export const FACTORY_WORLD: WorldDef = buildWorld(factoryWorldJson, factoryChaptersJson, [
  factoryCh1L1Json,
  factoryCh1L2Json,
  factoryCh1L3Json,
  factoryCh1L4Json,
  factoryCh1L5Json,
  factoryCh1L6Json,
  factoryCh2L1Json,
  factoryCh2L2Json,
  factoryCh2L3Json,
  factoryCh2L4Json,
  factoryCh2L5Json,
  factoryCh2L6Json,
  factoryCh3L1Json,
  factoryCh3L2Json,
  factoryCh3L3Json,
  factoryCh3L4Json,
  factoryCh3L5Json,
  factoryCh3L6Json,
  factoryCh4L1Json,
  factoryCh4L2Json,
  factoryCh4L3Json,
  factoryCh4L4Json,
  factoryCh4L5Json,
  factoryCh4L6Json,
  factoryCh4L7Json,
  factoryCh5L1Json,
  factoryCh5L2Json,
  factoryCh5L3Json,
  factoryCh5L4Json,
  factoryCh5L5Json,
  factoryCh5L6Json,
]);

export const ROOFTOPS_WORLD: WorldDef = buildWorld(rooftopsWorldJson, rooftopsChaptersJson, [
  rooftopsCh1L1Json,
  rooftopsCh1L2Json,
  rooftopsCh1L3Json,
  rooftopsCh1L4Json,
  rooftopsCh1L5Json,
  rooftopsCh1L6Json,
  rooftopsCh2L1Json,
  rooftopsCh2L2Json,
  rooftopsCh2L3Json,
  rooftopsCh2L4Json,
  rooftopsCh2L5Json,
  rooftopsCh2L6Json,
  rooftopsCh3L1Json,
  rooftopsCh3L2Json,
  rooftopsCh3L3Json,
  rooftopsCh3L4Json,
  rooftopsCh3L5Json,
  rooftopsCh3L6Json,
]);

export const WORLDS: readonly WorldDef[] = [FACTORY_WORLD, ROOFTOPS_WORLD];
